import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RequestConfig, ApiConfig } from '../../configs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private readonly CrudUrlGet = 'Read';
  private readonly CrudUrlCreate = 'Create';
  private readonly CrudUrlUpdate = 'Update';
  private readonly CrudUrlDelete = 'Delete';
  private readonly CrudUrlSave = 'Save';

  constructor(private http: HttpClient) { }

  async getRequest<T>(endpointBase: string): Promise<T> {
    return await this.http.get<T>(
      RequestConfig.getEndPoint(endpointBase),
      ApiConfig.getOptionsJWT()).toPromise();
  }

  async getRequestPaged<T>(endpointBase: string, page: number, itemsPerPage: number, sortby?: string, sortDirection?: string): Promise<T> {

    let linha = '?LinhasPorPagina=';
    if (endpointBase.indexOf('?') !== - 1) {
      linha = '&LinhasPorPagina=';
    }

    let sort = (sortby !== undefined && sortDirection !== undefined) ? `&Sort=${sortDirection}&Coluna=${sortby}` : "";

    return await this.http.get<T>(
      RequestConfig.getEndPoint(endpointBase + linha + itemsPerPage + '&Pagina=' + page + sort),
      ApiConfig.getOptionsJWT()).toPromise();
  }

  async postRequest<T>(endpointBase: string, object: object): Promise<T> {
    return await this.http.post<T>(
      RequestConfig.getEndPoint(endpointBase),
      JSON.stringify(object), ApiConfig.getOptionsJWT()).toPromise();
  }

  async crudGet<T>(endpointBase: string, page?: number, itemsPerPage?: number, sortby?: string, sortDirection?: string): Promise<T> {
    let endPoint = this.CrudUrlGet;
    if (page !== undefined && itemsPerPage !== undefined) {
      let sort = (sortby !== undefined && sortDirection !== undefined) ? `&Sort=${sortDirection}&Coluna=${sortby}` : "";
      endPoint += '?LinhasPorPagina=' + itemsPerPage + '&Pagina=' + page + sort;
    }

    return await this.http.get<T>(RequestConfig.getEndPoint(endpointBase + '/' + endPoint), ApiConfig.getOptionsJWT()).toPromise();
  }

  async crudsave<T>(endpointBase: string, object: object): Promise<T> {
    return await this.http.post<T>(
      RequestConfig.getEndPoint(endpointBase + '/' + this.CrudUrlSave),
      JSON.stringify(object), ApiConfig.getOptionsJWT()).toPromise();
  }
  async save<T>(endpoint: string, object: object): Promise<T> {
    return await this.http.post<T>(
      RequestConfig.getEndPoint(endpoint),
      JSON.stringify(object), ApiConfig.getOptionsJWT()).toPromise();
  }


  async cruddelete<T>(endpointBase: string, id: number): Promise<T> {
    return await this.http.post<T>(
      RequestConfig.getEndPoint(endpointBase + '/' + this.CrudUrlDelete + '?id=' + id), null,
      ApiConfig.getOptionsJWT()).toPromise();
  }

  async saveMultiPart<T>(url: string, json: object, logo: File): Promise<T> {
    const formData = new FormData();
    formData.append(`Image`, logo);
    formData.append('data', JSON.stringify(json));

    const h = ApiConfig.getHeaderJWT();
    return this.http.post<any>(
      RequestConfig.getEndPoint(url),
      formData,
      h
    ).toPromise();
  }

  getBytes(url: string): Promise<ArrayBuffer> {
    const h = ApiConfig.getHeaderJWT();
    return this.http.get<ArrayBuffer>(RequestConfig.getEndPoint(url), ApiConfig.getOptionsJWTBlob())
      .toPromise();
  }
}
